import { IconBlueShowmoreCn, IconBlueShowmoreEn, IconBlueShowmoreJp, IconBlueShowmoreKo } from '@assets/images/icon';

import constructionSop from '@assets/images/solution/ebook/1-1.avif';
import constructionSafety from '@assets/images/solution/ebook/2-1.avif';
import constructionEquipment from '@assets/images/solution/ebook/3-1.avif';
import manufacturingForklift from '@assets/images/solution/ebook/4-1.avif';
import manufacturingSteel from '@assets/images/solution/ebook/5-1.avif';
import manufacturingProcess from '@assets/images/solution/ebook/6-1.avif';
import retailExhibition from '@assets/images/solution/ebook/7-1.avif';
import retailMobile from '@assets/images/solution/ebook/8-1.avif';
import retailOffice from '@assets/images/solution/ebook/9-1.avif';
import logisticsAsset from '@assets/images/solution/ebook/10-1.avif';
import constructionManage from '@assets/images/solution/ebook/11-1.avif';
import medicalPatient from '@assets/images/solution/ebook/12-1.avif';
import medicalWaste from '@assets/images/solution/ebook/13-1.avif';
import cityDigital from '@assets/images/solution/ebook/14-1.avif';
import cityTraffic from '@assets/images/solution/ebook/15-1.avif';
import publicCrosswalk from '@assets/images/solution/ebook/16-1.avif';
import publicFire from '@assets/images/solution/ebook/17-1.avif';
import educationSafety from '@assets/images/solution/ebook/18-1.avif';
import publicSafety from '@assets/images/solution/ebook/19-1.avif';
import digitaltwin from '@assets/images/solution/ebook/20-1.avif';

export default {
  title: '솔루션 E-book 다운로드받기',
  desc: '지금 바로 오브로의 스마트 솔루션을 한눈에 확인해보세요.<br/>e-Book을 통해 실제 사례와 주요 기능을 간편하게 살펴볼 수 있습니다.',
  buttonText: '제안서 다운로드',

  thumbnail: {
    constructionSafety: constructionSafety,
    constructionSop: constructionSop,
    constructionEquipment: constructionEquipment,
    constructionManage: constructionManage,

    logisticsAsset: logisticsAsset,

    manufacturingProcess: manufacturingProcess,
    manufacturingSteel: manufacturingSteel,
    manufacturingForklift: manufacturingForklift,
    medicalPatient: medicalPatient,
    medicalWaste: medicalWaste,

    retailOffice: retailOffice,
    retailExhibition: retailExhibition,
    retailMobile: retailMobile,

    cityDigital: cityDigital,
    cityTraffic: cityTraffic,

    publicSafety: publicSafety,
    publicFire: publicFire,
    publicCrosswalk: publicCrosswalk,

    educationSafety: educationSafety,
    digitaltwin: digitaltwin,
  },
};
